import React, { useState } from 'react';
import {
  IAvailableWorkflowActions,
  ISubmissionMetadata
} from '@publishing-engine/domain/models';
import { FundingDisplay } from './FundingDisplay';
import { FundingEmptyState } from './FundingEmptyState';
import { Flex } from '@chakra-ui/react';
import FundingUpdateModal from './FundingUpdateModal';
import { FieldHeader } from '../common/FieldHeader';
import { FundingDiffModal } from './FundingDiffModal';
import { FormFieldFunding } from '@publishing-engine/domain/types/article';
import { EntryPoint } from 'src/utils/types';
import { useSubmissionFields } from 'src/hooks/useSubmissionFields';

type IProps = {
  formFieldDefinition: FormFieldFunding;
  value?: ISubmissionMetadata['funding'];
  previousValue?: ISubmissionMetadata['funding'];
  isEditable?: boolean;
  availableActions: IAvailableWorkflowActions;
  onChange: (value: ISubmissionMetadata['funding']) => void;
  entryPoint: EntryPoint;
  isUpdateRequired?:boolean
};

export const Funding: React.FC<IProps> = ({
  formFieldDefinition,
  value,
  previousValue,
  isEditable,
  availableActions,
  onChange,
  entryPoint,
  isUpdateRequired
}) => {
  const { checkFormFieldValueIsUpdated } = useSubmissionFields(entryPoint);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const isUpdated = checkFormFieldValueIsUpdated(formFieldDefinition.name);

  const hasValue = !!value?.exists;

  const editCallback = isEditable
    ? () => {
        setIsEditing(true);
      }
    : undefined;
  const [showDiffModal, setShowDiffModal] = useState<boolean>(false);
  const openDiffModal = () => setShowDiffModal(true);
  const closeDiffModal = () => setShowDiffModal(false);

  return (
    <Flex flexDirection={'column'} gap={2}>
      {isEditing && (
        <FundingUpdateModal
          formField={formFieldDefinition}
          isOpen={isEditing}
          value={value}
          onClose={() => {
            setIsEditing(false);
            onchange;
          }}
          onSubmit={value => {
            setIsEditing(false);
            onChange(value.metadata.funding);
          }}
        />
      )}

      {isUpdated && showDiffModal ? (
        <FundingDiffModal
          config={formFieldDefinition}
          value={value}
          previousValue={previousValue}
          onClose={closeDiffModal}
        />
      ) : null}

      <FieldHeader
        {...formFieldDefinition}
        label="Funding"
        isUpdated={isUpdated}
        editCallback={editCallback}
        onShowDiffModal={openDiffModal}
        availableActions={availableActions}
        entryPoint={entryPoint}
        sectionHeadingTextStyle="headingGroup"
        isUpdateRequired={isUpdateRequired}
      />

      {hasValue ? (
        <FundingDisplay value={value.value} />
      ) : (
        <FundingEmptyState fieldLabels={formFieldDefinition.params.labels} />
      )}
    </Flex>
  );
};
